import Cookies from "js-cookie";

import { CookieList } from "@/utils/enums";

class EcornerService {
    static getEcornerCookie(): string | undefined {
        return Cookies.get(CookieList.ECORDER_ID);
    }

    static getEcornerStoreIdCookie(): string | undefined {
        return Cookies.get(CookieList.ECORNER_STORE_ID);
    }

    static getEcornerTerminalIdCookie(): string | undefined {
        return Cookies.get(CookieList.ECORNER_TERMINAL_ID);
    }

    static getEcornerUrl(sku: string): {
        url?: string;
        urlParams?: Record<string, string>;
    } {
        const ecornerId = EcornerService.getEcornerCookie();
        if (ecornerId) {
            return {
                url: "/ecorners/:ecornerId/facing/:sku",
                urlParams: {
                    ecornerId,
                    sku
                }
            };
        }
        const ecornerStoreId = EcornerService.getEcornerStoreIdCookie();
        if (ecornerStoreId) {
            return {
                url: "/ecorners/facing/:storeId/:sku",
                urlParams: {
                    storeId: ecornerStoreId,
                    sku
                }
            };
        }

        return {};
    }

    static isEcornerEnvironment(): boolean {
        // Old ecorner environment
        if (EcornerService.getEcornerCookie()) {
            return true;
        }

        // New ecorner environment
        if (
            EcornerService.getEcornerStoreIdCookie() &&
            EcornerService.getEcornerTerminalIdCookie()
        ) {
            return true;
        }

        return false;
    }
}

export { EcornerService };
